import React, { useEffect, useState, useRef } from "react";
import ReactExport from "react-export-excel";
import { Button } from "antd";
import moment from 'moment';
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;



const Excelldownload = ({ data, from, loading }) => {
  // console.log(data);
  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"];
  let fileName = 'Overtime Statement';

  if (loading) {
    return <Button type="ghost" style={{ width: "100%", marginRight: "10px" }}>....Loading</Button>
  } else
    return (
      <ExcelFile element={<Button type="primary" style={{ width: "100%", marginRight: "10px" }}>Download</Button>} filename={fileName}>
        <ExcelSheet data={data} name='Overtime Statement'>
          <ExcelColumn label="Department" value="employeeDepartment" />
          <ExcelColumn label="Pin no." value="employeeId" />
          <ExcelColumn label="Name" value="employeeName" />
          <ExcelColumn label="Designation" value="employeeRole" />
          <ExcelColumn label="Basic salary" value="Basicsalary" />

          <ExcelColumn label="Rate/Hour" value="rate" />
          <ExcelColumn label="Total OT hour" value="extratime&overtime" />
          <ExcelColumn label="Deduction OT hour" value="overtime" />
          <ExcelColumn label="Payable OT hour" value="extratime" />
          <ExcelColumn label="Paybale OT Amount" value="overtimepayment" />

        </ExcelSheet>
      </ExcelFile>
    );
};

export default Excelldownload;
